export const environment = {
    production:false,
    apiUrl:'https://api.safescan.natrixsoftware.in/',
    version:'v1.9.1',
    showMedicationId: true
};